import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../shared/CiroButton";
import {
  AutopilotSessionCardCompletedActions_AutopilotSessionFragment,
  AutopilotSessionRunningState,
} from "../../../../__generated__/graphql";
import { useState } from "react";
import { PlayIcon } from "@heroicons/react/20/solid";
import AutopilotSessionContinueSearchModal from "../AutopilotSessionContinueSearchModal";
import { gql } from "@apollo/client";

export const AutopilotSessionCardCompletedActions_AutopilotSession = gql`
  fragment AutopilotSessionCardCompletedActions_AutopilotSession on AutopilotSession {
    id
    skipContactsOptions {
      skipContactsYouveAlreadySeen
    }
  }
`;

const AutopilotSessionCardCompletedActions = ({
  autopilotSession,
  setRunningState,
  contactsScanned,
  totalProfiles,
  runningState,
}: {
  autopilotSession: AutopilotSessionCardCompletedActions_AutopilotSessionFragment;
  setRunningState: (runningState: AutopilotSessionRunningState | null) => void;
  contactsScanned?: number | null;
  totalProfiles?: number | null;
  runningState: AutopilotSessionRunningState | null;
}) => {
  const [showRestartModal, setShowRestartModal] = useState(false);

  return (
    <>
      <div className={classNames("flex", "gap-1", "items-center")}>
        <CiroButton
          customClassName={classNames("rounded", "p-2", "hover:bg-gray-100")}
          style={CiroButtonStyleEnum.UNSTYLED}
          analyticsField="Restart completed autopilot session"
          onClick={() => {
            setShowRestartModal(true);
          }}
        >
          <div className={classNames("flex", "gap-1", "items-center")}>
            <PlayIcon className={classNames("w-4", "h-4", "text-orange-500")} />
            <div
              className={classNames(
                "text-xs",
                "text-orange-500",
                "font-semibold",
              )}
            >
              Continue search
            </div>
          </div>
        </CiroButton>
      </div>
      <AutopilotSessionContinueSearchModal
        isOpen={showRestartModal}
        onClose={() => {
          setShowRestartModal(false);
        }}
        autopilotSessionId={autopilotSession.id}
        onRestartedSession={setRunningState}
        contactsScanned={contactsScanned}
        totalProfiles={totalProfiles}
        runningState={runningState}
        initialSkipContactsYouveAlreadySeen={
          autopilotSession.skipContactsOptions?.skipContactsYouveAlreadySeen ??
          false
        }
      />
    </>
  );
};

export default AutopilotSessionCardCompletedActions;
